import * as Yup from "yup";

const AccountSchema = Yup.object().shape({
  account: Yup.string()
    .email("E-mail is not valid!")
    .required("E-mail is required!"),
});

export default AccountSchema;
